import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'visibleSelection',
  standalone: true,
})
export class FilterVisiblePipe implements PipeTransform {
  public transform(values: any[], ...args: unknown[]): any[] {
    return values.filter((v) => v.isVisible == true);
  }
}
